/** API `code` when cancel/delete is refused because the product is in offer formulas. */
export const CALCULATION_REQUIRED_PRODUCT_CODE = 'calculation_required_product';

/**
 * Alert shown when a catalog product cannot be cancelled or removed.
 * Keep in sync with calculation_required_restriction_message() in the backend.
 * @param {{ catalogs?: string[] }|null|undefined} info
 * @param {'status'|'delete'} action
 * @returns {string}
 */
export function buildCalculationRequiredRestrictionMessage(info, action) {
    const catalogs = Array.isArray(info?.catalogs)
        ? info.catalogs.map(label => String(label || '').trim()).filter(Boolean)
        : [];
    const catalogSuffix = catalogs.length ? ` (${catalogs.join(', ')})` : '';
    const usage =
        `Acest produs este utilizat în formulele de calcul ale ofertelor${catalogSuffix}.`;
    if (action === 'status') {
        return `${usage} Modificarea statusului în Anulat este restricționată.`;
    }
    return `${usage} Nu poate fi șters din listă și nu poate fi mutat în Anulat.`;
}

/**
 * Bulk status → Anulat: name the products that stay unchanged.
 * @param {Array<{ product_code?: string, catalogs?: string[] }>} products
 * @returns {string}
 */
export function buildCalculationRequiredBulkStatusMessage(products) {
    const entries = (products || []).filter((info) => info?.product_code);
    if (!entries.length) {
        return '';
    }
    const shown = entries.slice(0, 12).map((info) => {
        const catalogs = (info.catalogs || [])
            .map((label) => String(label || '').trim())
            .filter(Boolean);
        return catalogs.length
            ? `${info.product_code} (${catalogs.join(', ')})`
            : info.product_code;
    });
    const more = entries.length > shown.length
        ? ` și încă ${entries.length - shown.length}`
        : '';
    return (
        'Aceste produse sunt utilizate în formulele de calcul ale ofertelor'
        + ` și nu pot fi trecute în Anulat: ${shown.join(', ')}${more}.`
    );
}
